import React from 'react';
interface ValueStackProps {
  onAddToCart: () => void;
}
export function ValueStack({
  onAddToCart
}: ValueStackProps) {
  return <section className="py-20 md:py-28 px-4 bg-dark-primary" data-id="element-675">
      <div className="max-w-content mx-auto" data-id="element-676">
        <div className="bg-dark-card border border-gold/20 rounded-xl p-8 md:p-12 relative overflow-hidden" data-id="element-677">
          {/* Subtle background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[80%] h-[50%] bg-gold/5 blur-[80px] rounded-full pointer-events-none" data-id="element-678"></div>

          <div className="text-center mb-8 relative z-10" data-id="element-679">
            <span className="inline-block font-mono text-[11px] text-gold uppercase tracking-[0.2em]" data-id="element-680">
              Hoy todo por solo
            </span>
          </div>

          {/* Value Table */}
          <div className="space-y-4 mb-10 relative z-10" data-id="element-681">
            <div className="flex justify-between items-center py-3 border-b border-border-subtle" data-id="element-682">
              <span className="font-sans text-cream text-[16px]" data-id="element-683">
                El Azúcar Silencioso (Ebook 89 páginas)
              </span>
              <span className="font-mono text-gray-warm line-through" data-id="element-684">
                $27.00
              </span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-border-subtle" data-id="element-685">
              <span className="font-sans text-cream text-[16px]" data-id="element-686">
                Bonus #1: Decodificador de Etiquetas
              </span>
              <span className="font-mono text-gray-warm line-through" data-id="element-687">
                $9.95
              </span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-border-subtle" data-id="element-688">
              <span className="font-sans text-cream text-[16px]" data-id="element-689">
                Bonus #2: Mecanismo de Rescate
              </span>
              <span className="font-mono text-gray-warm line-through" data-id="element-690">
                $9.95
              </span>
            </div>
            <div className="flex justify-between items-center py-3 border-b border-border-subtle" data-id="element-691">
              <span className="font-sans text-cream text-[16px]" data-id="element-692">
                Bonus #3: Menú Semanal Anti-Glicación
              </span>
              <span className="font-mono text-gray-warm line-through" data-id="element-693">
                $14.95
              </span>
            </div>
            <div className="flex justify-between items-center pt-4" data-id="element-694">
              <span className="font-sans font-bold text-cream text-[18px]" data-id="element-695">
                Valor total del bundle
              </span>
              <span className="font-mono font-bold text-gray-warm line-through text-[18px]" data-id="element-696">
                $61.85
              </span>
            </div>
          </div>

          {/* Price Display */}
          <div className="text-center relative z-10 mb-10" data-id="element-697">
            <div className="mb-2" data-id="element-698">
              <span className="font-sans text-gold text-lg mr-3" data-id="element-699">
                Precio regular
              </span>
              <span className="font-mono text-gray-warm line-through text-xl" data-id="element-700">
                $27
              </span>
            </div>
            <div className="text-gold mb-2" data-id="element-701">↓</div>
            <div className="font-serif font-black text-7xl md:text-8xl text-gold mb-4 tracking-tight drop-shadow-[0_0_15px_rgba(201,168,76,0.3)]" data-id="element-702">
              $17.95
            </div>
            <div className="inline-block bg-green/10 border border-green/30 px-4 py-2 rounded-full" data-id="element-703">
              <span className="font-sans text-green font-medium text-sm" data-id="element-704">
                Ahorro inmediato de $43.90 sobre el valor total
              </span>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center relative z-10" data-id="element-705">
            <a href="https://www.godeskcore.com/cart/42794527916080:1" target="_blank" rel="noopener noreferrer" onClick={onAddToCart} className="inline-block w-full md:w-auto bg-gold hover:bg-[#D4B355] text-dark-primary font-sans font-bold text-xl py-5 px-10 rounded-md transition-all shadow-[0_0_20px_rgba(201,168,76,0.2)] hover:shadow-[0_0_30px_rgba(201,168,76,0.4)] hover:-translate-y-0.5" data-id="element-706">
              QUIERO EL EBOOK + 3 BONUS AHORA
            </a>
            <p className="mt-6 font-sans text-[13px] text-gray-warm leading-relaxed" data-id="element-707">
              Precio $27 · Oferta por tiempo limitado. Precio antiguo tachado y
              precio nuevo grande.
              <br data-id="element-708" />
              PDF digital · Descarga inmediata · Acceso de por vida · Pago
              seguro
            </p>
          </div>
        </div>
      </div>
    </section>;
}